import { useState, useEffect } from 'react';
import { Trophy, Loader2 } from 'lucide-react';
import { getGoalsLeaderboard } from '../lib/api';

export const CapocannonierePage = () => {
  const [scorers, setScorers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getGoalsLeaderboard();
        setScorers(res.data);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="py-8 px-4" data-testid="capocannoniere-page">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 border border-gold/20 rounded-full mb-4">
            <Trophy className="w-4 h-4 text-gold" />
            <span className="text-sm font-semibold text-gold uppercase tracking-wider">
              Top Scorer
            </span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter">
            CLASSIFICA <span className="text-gold">CAPOCANNONIERE</span>
          </h1>
          <p className="mt-3 text-slate-400">
            Gol segnati nelle fasi eliminatorie
          </p>
        </div>

        {scorers.length === 0 ? (
          <div className="glass-card p-12 text-center">
            <Trophy className="w-16 h-16 text-slate-600 mx-auto mb-4" />
            <h3 className="font-heading text-xl font-bold mb-2">Nessun marcatore</h3>
            <p className="text-slate-400">
              I gol verranno registrati a partire dai quarti di finale
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {scorers.map((scorer, idx) => {
              const isTop3 = idx < 3;
              const medalColors = [
                'bg-gradient-to-r from-gold/20 to-amber-600/10 border-gold/40',
                'bg-gradient-to-r from-slate-300/10 to-slate-400/5 border-slate-400/30',
                'bg-gradient-to-r from-orange-700/10 to-orange-800/5 border-orange-600/30',
              ];
              const positionColors = [
                'bg-gold text-slate-950',
                'bg-slate-400 text-slate-950',
                'bg-orange-600 text-white',
              ];

              return (
                <div
                  key={scorer.player_id}
                  className={`flex items-center gap-4 p-4 rounded-xl border transition-all ${
                    isTop3
                      ? medalColors[idx]
                      : 'bg-slate-900/50 border-slate-800 hover:border-slate-700'
                  }`}
                  data-testid={`scorer-row-${idx}`}
                >
                  {/* Position */}
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-lg shrink-0 ${
                    isTop3 ? positionColors[idx] : 'bg-slate-800 text-slate-400'
                  }`}>
                    {idx + 1}
                  </div>

                  {/* Player info */}
                  <div className="flex-1 min-w-0">
                    <p className={`font-heading font-bold truncate ${isTop3 ? 'text-lg' : 'text-base'}`}>
                      {scorer.player_name}
                    </p>
                    <p className="text-xs text-slate-400 truncate">{scorer.team_name}</p>
                  </div>

                  {/* Goals */}
                  <div className="text-right shrink-0">
                    <span className={`font-numbers font-bold ${isTop3 ? 'text-3xl text-gold' : 'text-2xl text-primary'}`}>
                      {scorer.total_goals}
                    </span>
                    <p className="text-[10px] text-slate-500 uppercase tracking-wider">gol</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CapocannonierePage;
